import { io } from 'socket.io-client';

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  connect(token) {
    if (this.socket?.connected) return;

    this.socket = io(process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000', {
      auth: { token },
      transports: ['websocket', 'polling'],
    });

    this.socket.on('connect', () => {
      console.log('Socket connected');
    });

    this.socket.on('disconnect', () => {
      console.log('Socket disconnected');
    });

    this.socket.on('connect_error', (err) => {
      console.error('Socket connection error:', err.message);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
    this.listeners.clear();
  }

  joinRoom(roomId) {
    this.socket?.emit('join_room', roomId);
  }

  leaveRoom(roomId) {
    this.socket?.emit('leave_room', roomId);
  }

  sendMessage(roomId, content, type = 'text', attachments = []) {
    this.socket?.emit('send_message', { roomId, content, type, attachments });
  }

  typing(roomId) {
    this.socket?.emit('typing', { roomId });
  }

  stopTyping(roomId) {
    this.socket?.emit('stop_typing', { roomId });
  }

  on(event, callback) {
    this.socket?.on(event, callback);
    this.listeners.set(event, callback);
  }

  off(event) {
    const callback = this.listeners.get(event);
    if (callback) {
      this.socket?.off(event, callback);
      this.listeners.delete(event);
    }
  }

  onNewMessage(callback) { this.on('new_message', callback); }
  onChatRoomUpdated(callback) { this.on('chat_room_updated', callback); }
  onNotification(callback) { this.on('notification', callback); }
  onTyping(callback) { this.on('user_typing', callback); }
  onStopTyping(callback) { this.on('user_stop_typing', callback); }
  onViolationAlert(callback) { this.on('violation_alert', callback); }
  onAdminAlert(callback) { this.on('admin_alert', callback); }
}

const socketService = new SocketService();
export default socketService;
